export default "__VITE_ASSET__YCSo2vaE__"